module.exports = __webpack_public_path__ + "static/img/study_report_official.afc4b04c.png";